module.exports = __webpack_public_path__ + "img/pin.212ab24b.png";